export default "__VITE_ASSET__ZR$ITe1W__"